<template>
  <div class="select-2 flex-center">
    <div class="select-title">
      <p class="title">互动广告智能投放</p>
      <p class="words">自动投放，定向目标人群，OCPA宣传，实时精准宣传</p>
    </div>
    <div class="put-list">
      <ul>
        <li>
          <div class="init flex-center">
            <img src="../../assets/images/mingzhi_icon_01.png" icon-class="base" class="icon" />
            <p>基本信息</p>
          </div>
        </li>
        <li>
          <div class="init flex-center">
            <img src="../../assets/images/mingzhi_icon_03.png" icon-class="base" class="icon" />
            <p>地域</p>
          </div>
        </li>
        <li>
          <div class="init flex-center">
            <img src="../../assets/images/mingzhi_icon_05.png" icon-class="base" class="icon" />
            <p>行为</p>
          </div>
        </li>
        <li>
          <div class="init flex-center">
            <img src="../../assets/images/mingzhi_icon_02.png" icon-class="base" class="icon" />
            <p>状态</p>
          </div>
        </li>
        <li>
          <div class="init flex-center">
            <img src="../../assets/images/mingzhi_icon_04.png" icon-class="base" class="icon" />
            <p>自定义</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "selectTwo",
    components: {}
  };
</script>

<style lang="scss" scoped>
  @import "~@/styles/index.scss";

  .select-2 {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    text-align: center;
    overflow: hidden;
    margin-top: 13px;

    .select-title {
      .title {
       font-size: 36px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
        margin-bottom: 14px;
        margin-top: 20px;
        opacity: 1;
        transition: all 1s;
      }

      .words {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }

    .put-list {
      padding-bottom: 70px;
      li {
        display: inline-block;
        overflow: hidden;
        position: relative;
        margin-right: 82px;
        margin-top: 43px;

        .init {
          width: 100%;
          height: 100%;

          .icon {
            width: 116px;
            height: 116px;
          }

          p {
            margin-top: 10px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(52, 52, 52, 1);
          }
        }

        .hover {
          p:nth-child(1) {
            margin-bottom: 24px;
          }

          p:nth-child(2) {
            width: 79px;
            height: 28px;
            font-size: 11px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }

      li:nth-child(5) {
        margin-right: 0;
      }
    }
  }
</style>